import {useEffect, useState} from 'react';

const BREAKPOINTS = {
    mobile: 640,
    tablet: 1024
};

export function useMediaQuery() {
    const [screenSize, setScreenSize] = useState(() => ({
        isMobile: typeof window !== 'undefined' ? window.innerWidth < BREAKPOINTS.mobile : false,
        isTablet: typeof window !== 'undefined'
            ? window.innerWidth >= BREAKPOINTS.mobile && window.innerWidth < BREAKPOINTS.tablet
            : false,
        isDesktop: typeof window !== 'undefined' ? window.innerWidth >= BREAKPOINTS.tablet : true
    }));

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            setScreenSize({
                isMobile: width < BREAKPOINTS.mobile,
                isTablet: width >= BREAKPOINTS.mobile && width < BREAKPOINTS.tablet,
                isDesktop: width >= BREAKPOINTS.tablet
            });
        };

        window.addEventListener('resize', handleResize);
        // Call once to ensure correct initial state
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return screenSize;
}
